
// Digital clock with date

function updateClock() {
    let now = new Date();
    let dayName = now.getDay(),
        month = now.getMonth(),
        dayNumber = now.getDate(),
        year = now.getFullYear(),
        hour = now.getHours(),
        minutes = now.getMinutes(),
        seconds = now.getSeconds();
        
    Number.prototype.pad = function(digits) {
        let n = this.toString();
        while (n.length < digits) {
          n = '0' + n;
        }
        return n;
    }
      
    const months = ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'];
    const week = ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'];
    const identifiers = ['day-name', 'month', 'day-number', 'year', 'hour', 'minutes', 'seconds'];
    let values = [week[dayName], months[month], dayNumber.pad(2), year, hour.pad(2), minutes.pad(2), seconds.pad(2)];

    for(let i = 0; i < identifiers.length; i++) {
        document.getElementById(identifiers[i]).firstChild.nodeValue = values[i];
    }
}

function initClock() {
    updateClock(); 
    window.setInterval(updateClock, 1000); 
}

window.addEventListener('load', initClock);
